import React from 'react';
import styled from 'styled-components';

import { Header } from '@summer/ui-components';

import { OnboardingContainer } from 'components/pages/onboarding/shared';
import SecurityHeader from 'components/pages/onboarding/shared/SecurityHeader';
import { CreateAccountHeader } from 'components/pages/userIdentityVerification/CreateAccountHeader';

export const MfaPageContainer = ({
  header,
  children,
  testId,
  showCreateAccountHeader = false,
}) => {
  return (
    <>
      <OnboardingContainer data-testid={testId}>
        {showCreateAccountHeader && (
          <CreateAccountHeader
            title="Create Account"
            currentStep={3}
            totalSteps={3}
          />
        )}
        {header && (
          <>
            <SecurityHeader />
            <HeaderContainer>
              <Header h2 center>
                {header}
              </Header>
            </HeaderContainer>
          </>
        )}
        {children}
      </OnboardingContainer>
    </>
  );
};

const HeaderContainer = styled.div`
  margin-bottom: 10px;
`;
